export default "__VITE_ASSET__055832ed__"